import axios from "axios";
export const actions = {
        activeParentType({commit, state}, type) {
          commit("activeParentType", type);
          commit("incrementGoogleMapStateKey");
        },
        setGoogle({ commit }, google) {
          commit("setGoogle", google);
        },
        getOperatorData({ commit, dispatch, state }, payload) { // TODO: P10 - get first page of operators, then the rest
          if(state.cache) {
            let lsoperators = sessionStorage.getItem("operators-" + state.sessionStorageKey);
            if (lsoperators) {
              commit("updateOperatorData", JSON.parse(lsoperators));
              state.isLoading = false;
              return true;
            }
          }
          let after = "";
          if (payload) {
            after = payload.after;
          }
          axios({
            url: `${state.baseUrl}/graphql`,
            method: "post",
            data: {
              query: `
              query getOperators($after: String) {
                operators(first: 999, after: $after) {
                  pageInfo {
                    hasNextPage
                    endCursor
                  }
                  nodes {
                    id
                    operatorId
                    title
                    slug
                    operatorCategories {
                      nodes {
                        databaseId
                      }
                    }
                    facilities {
                      nodes {
                        name
                        slug
                        databaseId
                      }
                    }
                    OperatorData {
                      operatorMapMarker {
                        latitude
                        longitude
                        streetAddress
                      }
                      operatorImages {
                        mediaItemId
                        sourceUrl(size: MEDIUM_LARGE)
                      }
                      operatorPetFriendly
                      operatorAccessibility
                    }
                  }
                }
              }                           
              `,
              variables: {
                after: after
              }
            }
          }).then(response => {
            let operators = response.data.data.operators.nodes;
            commit("updateOperatorData", operators);
            if (response.data.data.operators.pageInfo.hasNextPage === true) {
              dispatch("getOperatorData", {
                after: response.data.data.operators.pageInfo.endCursor
              });
            } else {
              if(state.cache) {
                sessionStorage.setItem(
                  "operators-" + state.sessionStorageKey,
                  JSON.stringify(state.operatorData)
                );
              }
              state.isLoading = false;
              state.googleMapStateKey++;
            }
          });
        },
        getAccessible({ commit, state }) {
          axios({
            url: `${state.baseUrl}/graphql`,
            method: "post",
            data: {
              query: `
              {
                accessibles {
                  nodes {
                    name
                    slug
                  }
                }
              }                   
              `
            }
          }).then(response => {
            if(!response.data.data) return;
            let accessible = response.data.data.accessibles.nodes;
            commit("updateAccessible", accessible);
          });
        },
        getOperatorCategories({dispatch, commit, state}) {
          if(state.cache) {
            let lscategories = sessionStorage.getItem("categories" + state.sessionStorageKey);
            if (lscategories) {
              commit("updateCategories", JSON.parse(lscategories));
              dispatch("getState"); // need to wait until categories object has been populated - see commit("updateCategories", categories);
              return true;
            }
          }
          axios({
            url: `${state.baseUrl}/graphql`,
            method: "post",
            data: {
              query: `
              query GetOperatorCategories {
                operatorCategories(first:999, where: {hideEmpty: true}) {
                  nodes {
                    databaseId
                    slug
                    name
                    categoryColour {
                      colour
                    }
                    parentDatabaseId
                    children(where: {hideEmpty: true}) {
                      nodes {
                        databaseId
                        slug
                        name
                        parent {
                          node {
                            databaseId
                          }
                        }
                      }
                    }
                  }
                }
              }                
              `
            }
          }).then(response => {
            if(!response.data.data) return;
            let categories = response.data.data.operatorCategories.nodes.filter( cat => !cat.parentDatabaseId );
            commit("updateCategories", categories);
            if(state.cache) {
              sessionStorage.setItem(
                "categories" + state.sessionStorageKey,
                JSON.stringify(state.categories)
              );
            }
          }).then(() => {
            dispatch("getState"); // need to wait until categories object has been populated - see commit("updateCategories", categories);
          }).then(() => {
            if(window.pageInfo && state.tripPlannerPageId === window.pageInfo.post_id) {
              if (state.tripPlannerData.length > 0) {
                state.tripPlannerData.forEach(id => {
                  commit("getTripPlannerData", id);
                });
                state.googleMapStateKey++;
              }
            }
          })
        },
    
        getState({dispatch, commit, state}) {
          let pageId = null
          if(state.local) {
            pageId = 2
          } else {
            pageId = parseInt(window.pageInfo.post_id)
          }
          // pageId = 1007
          axios({
            url: `${state.baseUrl}/graphql`,
            method: "post",
            data: {
              query: `
              query GetState {
                page( idType: DATABASE_ID, id: `+pageId+`) {
                  atdwFeed {
                    activeView
                    showAtdwFeed
                    categories {
                      databaseId
                      name
                      slug
                      parent {
                        node {
                          databaseId
                        }
                      }
                    }
                  }
                }
              }
              `
            }
          }).then(response => {
            let payload = null
            if(response.data.data.page)
              payload = response.data.data.page.atdwFeed
            if(response.data.data.post)
              payload = response.data.data.post.atdwFeed
            if(response.data.data.event)
              payload = response.data.data.event.atdwFeed
            if(payload && payload.activeView)
              commit("activeParentType", payload.activeView)
            if(payload && payload.categories && payload.categories.length > 0) {
              let categoriesArray = []
              payload.categories.forEach(category => {
                if(category.parent === null) {
                  commit("toggleDirectoryCategories", category.databaseId)
                } else {
                  const {parent, ...cleanCategory} = category // remove 'parent' property from object
                  if(categoriesArray.length < 1) {
                    categoriesArray.push({
                      subcategories: [cleanCategory],
                      parentId: category.parent.node.databaseId
                    })
                  } else {
                    categoriesArray.forEach((cat) => {
                      if(cat.parentId && cat.parentId === category.parent.node.databaseId) {
                        cat.subcategories.push(cleanCategory)
                      } else {
                        categoriesArray.push({
                          subcategories: [cleanCategory],
                          parentId: category.parent.node.databaseId
                        })
                      }
                    })
                  }
                }
              })
              if(categoriesArray.length > 0) {
                categoriesArray.forEach((category) => {
                  commit("updateSubcategories", category)
                })
              }
            }
          }).then(() => {
            if(!window.trip_planner !== "true") {
              dispatch("getOperatorData");
            }
          }).then(() => {
            if(window.active_category) {
              let payload = {
                // parentId: null,
                subcategories: []
              }
              window.active_category.forEach((activeCategory) => {
                state.categories.forEach((category) => {
                  category.children.nodes.forEach((subcategory) => {
                    if(subcategory.slug === activeCategory) {
                      payload.parentId = category.databaseId
                      payload.subcategories.push(subcategory)
                    }
                  })
                })
              })
              commit("updateSubcategories", payload)
            }
          });
        }
}